:host {
  /** @prop --notification-banner-icon-color: Icon color in the notification banner. */
  --notification-banner-icon-color: var(--s-color-icon-system);

  /** @prop --notification-banner-text-color: Text color in the notification banner. */
  --notification-banner-text-color: var(--s-color-text-default);

  /** @prop --notification-banner-font-family: Font family for the notification banner text. */
  --notification-banner-font-family: inherit;

  /** @prop --notification-banner-font-size: Font size for the notification banner text. */
  --notification-banner-font-size: var(--s-size-text-default);

  /** @prop --notification-banner-font-weight: Font weight for the notification banner text. */
  --notification-banner-font-weight: var(--s-font-weight-paragraph-default);

  /** @prop --notification-banner-inline-spacing: Spacing between inline elements in the notification banner. */
  --notification-banner-inline-spacing: var(--p-size-static-300);

  /** @prop --notification-banner-line-height: Line height for the notification banner text. */
  --notification-banner-line-height: var(--s-size-line-height-paragraph);

  /** @prop --notification-banner-background-color: Background color of the notification banner. */
  --notification-banner-background-color: var(--b-color-info-light);

  /** @prop --notification-banner-border-color: Border color of the notification banner. */
  --notification-banner-border-color: var(--s-color-border-info);

  /** @prop --notification-banner-max-width: Maximum width of the notification banner. */
  --notification-banner-max-width: var(--max-width, 1170px);

  /** @prop --notification-banner-border-width: Width of the notification banner border. */
  --notification-banner-border-width: 0px 0px var(--border-width, var(--b-size-border-width-large)) 0px;

  /** @prop --border: Border style for the notification banner. */
  --border: var(--notification-banner-border-width) solid var(--notification-banner-border-color);

  .anchor-c-notification-banner {
    box-sizing: border-box;
    border: var(--border);
    display: flex;
    gap: var(--notification-banner-inline-spacing);
    background-color: var(--notification-banner-background-color);
    font-size: var(--notification-banner-font-size);
    font-weight: var(--notification-banner-font-weight);
    font-family: var(--notification-banner-font-family);
    line-height: var(--notification-banner-line-height);
    border-style: solid;
    border-color: var(--notification-banner-border-color);
    border-width: var(--notification-banner-border-width);
    padding-top: var(--p-size-static-100);
    padding-bottom: var(--p-size-static-500);
    // To center the notification banner when the viewport is wider than the max-width
    padding-right: max(var(--p-size-static-100), 50vw - var(--notification-banner-max-width) / 2);
    padding-left: max(var(--p-size-static-300), 50vw - var(--notification-banner-max-width) / 2);
    &__text {
      display: flex;
      flex-direction: column;
      align-items: left;
      flex-wrap: wrap;
      margin-top: var(--p-size-static-200);
      // Set the width of the text to half of the notification banner width, but not less than 50ch and not more than 75ch
      width: clamp(50ch, calc(50% - 24px - var(--notification-banner-inline-spacing)), 75ch);
    }
    &__close-icon {
      cursor: pointer;
      margin-left: auto;
      --icon-button-color: var(--s-color-icon-system);
    }
  }
  .info {
    --notification-banner-background-color: var(--b-color-info-light);
    --notification-banner-border-color: var(--s-color-border-info);
  }
  .warning {
    --notification-banner-background-color: var(--b-color-warning-light);
    --notification-banner-border-color: var(--s-color-border-warning);
  }
  .error {
    --notification-banner-background-color: var(--b-color-error-light);
    --notification-banner-border-color: var(--s-color-border-error);
  }
  .success {
    --notification-banner-border-color: var(--s-color-border-succes);
    --notification-banner-background-color: var(--b-color-succes-light);
  }
  ::slotted([slot='header']) {
    font-weight: bold;
  }
  .anchor-c-notification-banner__icon {
    margin-top: var(--p-size-static-200);
    --icon-color: var(--notification-banner-icon-color);
  }
  ::slotted(a) {
    margin-top: var(--p-size-static-300);
    color: var(--notification-inline-text-color);
    line-height: var(--s-size-line-height-paragraph);
  }
}
